module.exports = __webpack_public_path__ + "img/zhifubao code.6295c0ff.png";